import React from 'react';
import styled from 'styled-components';
import { WELCOME_KIT_ITEMS, WELCOME_KIT_VALUE } from './welcomeKit';

// Sized at ~2/3 of the Sep 16 build per Ethan's Sep 19 Figma comments.
const Shelf = styled.section<{ $standalone?: boolean }>`
  margin: 12px -16px -16px;
  padding: 10px 10px 12px;
  background: #f5f9ff;
  border-top: 1px solid #e1edff;
  border-radius: 0 0 16px 16px;
  font-family: Lato, sans-serif;
  text-align: center;

  @media (min-width: 768px) { padding: 15px 16px 16px; }

  /* web40 v2: one light-blue container under the Start Free Trial button. */
  ${({ $standalone }) => $standalone && `
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    padding: 12px 10px 14px;
    border: 1px solid #e1edff;
    border-radius: 16px;
    @media (min-width: 768px) { padding: 16px 16px 18px; }
  `}
`;

const Heading = styled.h3`
  margin: 0;
  color: #0b6dff;
  font-size: 11px;
  font-weight: 900;
  line-height: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  small { font-size: 8px; white-space: nowrap; }

  @media (min-width: 768px) {
    font-size: 13px;
    line-height: 17px;
    small { font-size: 9px; }
  }
`;

const Gifts = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-content: center;
  gap: 6px;
  list-style: none;
  max-width: 300px;
  margin: 8px auto 0;
  padding: 0;

  @media (min-width: 768px) { gap: 26px; max-width: 480px; margin-top: 12px; }
`;

const Gift = styled.li`
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageTile = styled.div`
  box-sizing: border-box;
  width: 64px;
  max-width: 100%;
  aspect-ratio: 1;
  padding: 4px;
  background: white;
  border: 1px solid #cbdfff;
  border-radius: 9px;
  margin-bottom: 6px;

  img { display: block; width: 100%; height: 100%; object-fit: contain; }

  @media (min-width: 768px) { width: 108px; padding: 7px; border-radius: 10px; margin-bottom: 8px; }
`;

const Value = styled.div`
  color: #317a40;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  padding-top: 1px;
  margin-bottom: 3px;
  white-space: nowrap;

  s { color: #6f7c8e; margin-right: 5px; }

  @media (min-width: 768px) { font-size: 11px; line-height: 14px; margin-bottom: 4px; }
`;

const GiftName = styled.div`
  max-width: 100%;
  min-height: 26px;
  color: #24354d;
  font-size: 11px;
  font-weight: 700;
  line-height: 13px;

  @media (min-width: 768px) { font-size: 12px; line-height: 15px; min-height: 30px; }
`;

const Note = styled.p`
  margin: 7px 0 0;
  color: #7d8da6;
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;

  @media (min-width: 768px) { font-size: 11px; line-height: 14px; margin-top: 10px; }
`;

export function WelcomeKitShelf({ standalone = false }: { standalone?: boolean }) {
  return (
    <Shelf aria-label="Your free welcome kit" $standalone={standalone} data-kit-shelf={standalone ? "below-cta" : "in-card"}>
      <Heading>Your free welcome kit <small>(${WELCOME_KIT_VALUE} value)</small></Heading>
      <Gifts>
        {WELCOME_KIT_ITEMS.map(item => (
          <Gift key={item.id}>
            <ImageTile><img src={item.image} alt="" /></ImageTile>
            <Value><s>${item.value}</s> FREE</Value>
            <GiftName>
              {item.id === 'shaker_bottle' ? <>Custom<br />Shaker Bottle</> :
                item.id === 'transformation_banner' ? <>Transformation<br />Banner</> : item.name}
            </GiftName>
          </Gift>
        ))}
      </Gifts>
      <Note>Included with your annual membership.</Note>
    </Shelf>
  );
}
